module.exports = __webpack_public_path__ + "img/opensea.fa391a9d.png";